import React from 'react';
import { SectionFade } from './ui/SectionFade';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ["Sientes que el marketing de los productos 'fit' te confunde.", 'Quieres proteger la salud de tus hijos de colorantes y aditivos neurotóxicos.', 'Sufres de inflamación, gases o bajones de energía después de comer.', 'Estás cansado de gastar dinero en comida cara que no te nutre.'];
const notForYou = ['No te importa la procedencia ni la calidad de lo que ingieres.', 'Prefieres seguir confiando ciegamente en las grandes corporaciones.', 'Buscas una dieta restrictiva de pasar hambre (esto es sobre calidad, no cantidad).'];
export function WhoIsItFor() {
  return <section className="py-24 px-4 bg-brand-dark" data-id="element-197">
      <div className="max-w-6xl mx-auto" data-id="element-198">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8" data-id="element-199">
          {/* IS FOR YOU */}
          <SectionFade data-id="element-200">
            <div className="bg-brand-black p-8 md:p-10 rounded-2xl border-t-4 border-brand-neon h-full" data-id="element-201">
              <h2 className="font-bebas text-5xl md:text-6xl mb-8 tracking-tight text-white" data-id="element-202">
                ESTO ES PARA TI <span className="text-brand-neon" data-id="element-203">SI:</span>
              </h2>
              <ul className="space-y-6" data-id="element-204">
                {forYou.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-205">
                    <div className="bg-brand-neon/20 p-1 rounded-full mt-1 shrink-0" data-id="element-206">
                      <CheckIcon className="text-brand-neon" size={20} data-id="element-207" />
                    </div>
                    <p className="font-inter text-gray-300 text-lg leading-relaxed" data-id="element-208">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </SectionFade>

          {/* NOT FOR YOU */}
          <SectionFade delay={0.2} data-id="element-209">
            <div className="bg-brand-black p-8 md:p-10 rounded-2xl border-t-4 border-red-500 h-full" data-id="element-210">
              <h2 className="font-bebas text-5xl md:text-6xl mb-8 tracking-tight text-white" data-id="element-211">
                ESTO NO ES PARA TI <span className="text-red-500" data-id="element-212">SI:</span>
              </h2>
              <ul className="space-y-6" data-id="element-213">
                {notForYou.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-214">
                    <div className="bg-red-500/20 p-1 rounded-full mt-1 shrink-0" data-id="element-215">
                      <XIcon className="text-red-500" size={20} data-id="element-216" />
                    </div>
                    <p className="font-inter text-gray-400 text-lg leading-relaxed" data-id="element-217">
                      {item}
                    </p>
                  </li>)}
              </ul>
            </div>
          </SectionFade>
        </div>
      </div>
    </section>;
}